<template>
    <div class="modal-content-detail">
        <div class="left">
            <template v-for="(name,index) in details">
                <div class="left-cell" v-if="name.refeeType!='S2'" :class="currentIndex==index?'cell-active':''"  @click="handleChange(name,index)"  :key="index">{{name.refeeType=='S1'?'视线裁判':name.refeeName}}</div> 
            </template>            
        </div>
        <div class="right">
            <div class="header">
                <div class="score" >                
                    <div class="column-cell cell-blue" >{{details[currentIndex].record}}</div>
                    <div class="column-cell cell-blue" v-if="currentIndex==3">{{details[currentIndex+1].record}}</div>
                </div>
                <div class="back" @click="handleBackContentDetail">返回</div>
            </div>
            <GymsList v-if="!mapDetail&&gameScoreData" :gameScoreData="gameScoreData"></GymsList>
            <GymsSeeMap v-if="mapDetail&&gameScoreData" :gameScoreData="gameScoreData"></GymsSeeMap>
        </div>
    </div>
</template>

<script>
import GymsList from './GymsList.vue'
import GymsSeeMap from './GymsSeeMap.vue'
export default {
  name:'GymsModalContentDetail',
  props:['scoreDetail','details','showMapData'],
  components: {
    GymsList,
    GymsSeeMap
  },
  data () {
    return {
      currentIndex:0,   
      gameScoreData:[],
      refeeType:'',
      mapDetail:false
    }
  },
  mounted () {
    //内容页进入详情页数据处理
    this.currentIndex=this.scoreDetail.index
    this.refeeType=this.details[this.currentIndex].refeeType
    this.mapDetail=this.scoreDetail.mapDetail
    this.gameScoreData=null
    this.getGameScoreData()
  },
  methods: {
    //切换裁判类型
    handleChange (name,index) {
      this.currentIndex=index
      if(name.refeeType=='S1'||name.refeeType=='S2'){
        this.mapDetail=true
        this.refeeType='S1'
        this.currentIndex=3
      }else{
        this.mapDetail=false
        this.refeeType=name.refeeType
      }
      this.gameScoreData=null
      this.getGameScoreData()
    },
    handleBackContentDetail (){
      //切换对战分数组件
      this.$emit('handleChangeDetail',false)
    },
    //获取对战分数详情
    getGameScoreData (){
      let data={}
      data.pkId=this.scoreDetail.pkId
      data.refeeType=this.details[this.currentIndex].refeeType
      this.$api.match.macthGameScoreGyms(data).then((res)=>{
        if(res.status==0){
          this.gameScoreData=res.data
        }else{
          this.$message.info('请求错误')
        }
      })
    }
  },

}
</script>

<style lang="scss" scoped>
.modal-content-detail{
    width: 1100px;
    display: flex;
    justify-content: flex-start;
    .left{
        width: 150px;
        height: 480px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding-top: 5px;
        .left-cell{
            width: 100%;
            height: 100%;
            text-align: center;
            display: flex;
            flex: 1;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            color: #333333;
            background-color: #EDEDED;
            cursor: pointer;
        }
        .cell-active{
            background-color: #ffffff;
        }
    }
    .right{
       width: 100%;
        // height: 350px;
        position: relative;
        .header{
            //分数
            display: flex;
            justify-content: space-between;
            .score{
                padding: 15px 30px;
                width: 100%;
                display: flex;
                .column-cell{
                        width: 120px;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        color: #ffffff;
                        font-weight: bold;
                        font-size: 16px;
                        margin-bottom: 10px;
                        margin-right: 10px;
                }
                .cell-blue{
                    background-color: #2364B9;
                }
                .cell-red{
                    background-color: #D53F48;
                }
                
            }
            .back{
                width: 60px;
                line-height: 30px;
                cursor: pointer;
                text-align: right;
            }
         }
       
    }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/gyms/GymsModalContentDetail.vue